module.exports = __webpack_public_path__ + "static/media/copy_icon.ba2d68b3.svg";